<template>
    <crud-container :name="name">
        <crud-nav>
            <crud-nav-header title="Contacts"></crud-nav-header>


            <crud-nav-scroll>
                <div class="mt-4" v-for="(contactList, type) in items">
                    <heading size="medium">{{ type }}</heading>
                    <ul>
                        <li v-for="contact in contactList"
                            class="contact m-0 p-4 bg-white hover:bg-gray-50 rounded-2xl mt-0 mb-0"
                            @click="viewItem(contact)">

                            <div class="name" v-if="contact.has_company_and_person">
                                <a href="#" @click="viewItem(contact)">{{ contact.name }}
                                    <small>{{ contact.company }}</small>
                                </a>
                            </div>
                            <div v-else>
                                <div class="name" v-if="contact.has_person">
                                    <a href="#">{{ contact.name }}</a>
                                </div>
                                <div class="name" v-else>
                                    <a href="#">{{ contact.company }}</a>
                                </div>
                            </div>
                            <div class="meta">
                                <div href="#" class="text-gray-600 flex">
                                    <div class="flex-1">{{ contact.position }}</div>
                                    <div class="flex-1 text-right">
                                        <div v-if="contact.phone" class="cursor-pointer">
                                            <i class="far fa-clone text-blue-400 opacity-25 pr-0.5 hover:opacity-100"
                                               @click="clipboard(contact.phone)"></i>
                                            <a :href="'tel:'+contact.phone">{{ contact.phone }}</a>
                                        </div>
                                        <div class="cursor-pointer">
                                            <i class="far fa-clone text-blue-400 opacity-25 pr-0.5 hover:opacity-100"
                                               @click="clipboard(contact.email)"></i>
                                            <a :href="'mailto:'+contact.email+'?subject='+packageName">{{
                                                    contact.email
                                                }}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </li>
                    </ul>
                </div>
            </crud-nav-scroll>
        </crud-nav>

        <crud-main>
            <crud-new>
                <crud-main-header title="Link New Contact" can-go-back-to-nav="true"></crud-main-header>

                <crud-errors :errors="errors"></crud-errors>

                <dl>
                    <dt>Contact Type</dt>
                    <dd>
                        <v-select v-model="new_item.type"
                                  placeholder="Contact type."
                                  :options="contact_types">
                        </v-select>
                    </dd>
                    <dt>Person</dt>
                    <dd>
                        <v-select :on-search="getPeople" v-model="new_item.person"
                                  placeholder="Choose a person."
                                  :options="people"
                                  @change="personSelected"
                        >
                            <span slot="no-options">Start typing to find people.</span>
                        </v-select>
                    </dd>
                    <dt>Company</dt>
                    <dd>
                        <v-select :on-search="getCompanies" v-model="new_item.company"
                                  placeholder="Choose a company."
                                  :options="companies">
                            <span slot="no-options">Start typing to find companies.</span>
                        </v-select>
                    </dd>
                    <dt>Contact Position</dt>
                    <dd><input type="text" v-model="new_item.position" placeholder="Position"/></dd>
                </dl>

                <div class="action-button-group">
                    <a href="#" class="action-button action-button-dismiss hidden-desktop" @click.prevent="backToNav()">
                        <i class="fa fa-chevron-left" aria-hidden="true"></i> Back
                    </a>
                    <ui-button-new primary @click.prevent="addItem()">Add Contact
                        <i class="flex-shrink-0 ml-2 far fa-plus-square"></i>
                    </ui-button-new>
                </div>
            </crud-new>
            <crud-view>
                <crud-main-header :title="current_item.title" can-delete="true" can-go-back-to-nav="true"
                                  :item="current_item"></crud-main-header>

                <heading size="huge" v-if="current_item.position">{{ current_item.position }}
                    <template v-if="current_item.has_company"> at {{ current_item.company }}</template>
                </heading>
                <template v-if="!edit">
                    <div class="">
                        <div v-if="current_item.has_person" class="person-meta">
                            <heading size="medium">Personal Details</heading>
                            <dl>
                                <dt>Address</dt>
                                <dd>{{ current_item.person_address }}</dd>
                                <dt>Postcode</dt>
                                <dd>{{ current_item.person_postcode }}</dd>
                                <dt>Email</dt>
                                <dd>{{ current_item.person_email }}</dd>
                                <dt>Phone</dt>
                                <dd>{{ current_item.person_phone }}</dd>
                                <dt>Phone (Secondary)</dt>
                                <dd>{{ current_item.person_secondary_phone }}</dd>
                            </dl>
                        </div>
                        <div v-if="current_item.has_company" class="company-meta">
                            <heading size="medium">Company Details</heading>
                            <dl>
                                <dt>Company</dt>
                                <dd>{{ current_item.company }}</dd>
                                <dt>Address</dt>
                                <dd>{{ current_item.company_address }}</dd>
                                <dt>Postcode</dt>
                                <dd>{{ current_item.company_postcode }}</dd>
                                <dt>Email</dt>
                                <dd>{{ current_item.company_email }}</dd>
                                <dt>Phone</dt>
                                <dd>{{ current_item.company_phone }}</dd>
                                <dt>Fax</dt>
                                <dd>{{ current_item.company_fax }}</dd>
                                <dt>Website</dt>
                                <dd><a :href="current_item.company_website">{{ current_item.company_website }}</a></dd>
                            </dl>
                        </div>
                    </div>
                    <div class="mt-2 text-right">
                        <ui-button-new primary @click="goEdit()">Edit Contact
                            <i class="flex-shrink-0 ml-2 fas fa-edit"></i>
                        </ui-button-new>
                    </div>
                </template>
                <template v-else>
                    <dl>
                        <dt>Contact Type</dt>
                        <dd>
                            <v-select v-model="edit_item.type"
                                      placeholder="Contact type."
                                      :options="contact_types">
                            </v-select>
                        </dd>
                        <dt>Company</dt>
                        <dd>
                            <v-select :on-search="getCompanies" v-model="edit_item.company"
                                      placeholder="Choose a company."
                                      :options="companies">
                                <span slot="no-options">Start typing to find companies.</span>
                            </v-select>
                        </dd>
                        <dt>Contact Position</dt>
                        <dd><input type="text" v-model="edit_item.position" placeholder="Position"/></dd>
                    </dl>
                    <div class="action-button-group">
                        <ui-button-new @click.prevent="edit=false">Cancel</ui-button-new>
                        <ui-button-new primary @click.prevent="updateItem()" class="ml-2">Save Contact
                            <i class="flex-shrink-0 ml-2 far fa-edit"></i>
                        </ui-button-new>
                    </div>

                </template>
            </crud-view>
        </crud-main>
    </crud-container>
</template>

<script>
import vSelect from "vue-select";
import {cloneDeep} from "lodash";

export default {
    components: {
        vSelect
    },
    props: {
        'packageId': String,
        'packageName': String,
    },
    data() {
        return {
            name: 'package-contacts-list',
            items: [],
            current_item: {},
            new_item: {},
            people: [],
            companies: [],
            search_query: '',
            errors: null,
            contact_types: [
                {label: "Staff", value: "Staff"},
                {label: "Client", value: "Client"},
                {label: "Supplier", value: "Supplier"}
            ],
            edit: false,
            edit_item: {},
        }
    },
    watch: {},
    computed: {
        has_query() {
            return this.search_query != '' && !_.isNull(this.search_query);
        }
    },
    methods: {
        goEdit() {
            this.edit_item = cloneDeep(this.current_item)
            this.edit = true
        },
        updateItem() {
            var data = {
                'id': this.current_item.id,
                'contact_type': (_.isObject(this.edit_item.type) ? this.edit_item.type.value : this.edit_item.type),
                'position': this.edit_item.position,
                'company_id': (_.isObject(this.edit_item.company) ? this.edit_item.company.value : this.edit_item.company_id),
            };

            let updateUrl = appUrls.packages.contacts.update.replace('REPLACEME', this.packageId);

            axios.request({
                method: 'put',
                url: updateUrl,
                data: data
            }).then(response => {
                let item = response.data.data;
                this.edit_item = {};
                this.getItems();
                this.current_item = item;
                this.viewItem(item);
            }).catch(function (error) {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                }
            });

            this.edit = false;
        },
        personSelected() {
            let id = this.new_item.person ? this.new_item.person.data.companyId : null;
            if (id) {
                const option = {label: this.new_item.person.data.company, value: id};
                this.companies.push(option)
                this.new_item.company = option
                this.new_item.position = this.new_item.person.data.position
            }
        },
        clipboard(text) {
            navigator.clipboard.writeText(text);
        },
        getCompanies: _.debounce(function (search, loading) {
            var that = this;

            if (!search) {
                return;
            }

            loading(true);
            that.companies = [];
            axios.get(appUrls.companies.index, {params: {'query': search}})
                .then(response => {
                    _.forEach(response.data.data, function (company) {
                        that.companies.push({
                            label: company.name,
                            value: company.id
                        });
                    });
                    loading(false);
                });
        }, 500),
        getPeople: _.debounce(function (search, loading) {
            var that = this;

            if (!search) {
                return;
            }

            loading(true);
            that.people = [];
            axios.get(appUrls.contacts.index, {params: {'query': search}})
                .then(response => {
                    _.forEach(response.data.data, function (person) {
                        if (person) {
                            let label = person.name.trim();
                            if (person.company) {
                                label += ' (' + person.company.trim() + ')'
                            }
                            that.people.push({
                                label: label,
                                value: person.id,
                                data: person,
                            });
                        }
                    });
                    loading(false);
                });
        }, 500),
        deleteItem(itemToDelete) {
            var that = this;
            var title = 'Are you sure you want to remove ' + itemToDelete.name + ' as a contact?';
            var description = 'You are removing ' + itemToDelete.name + ' as a contact. They can always be re-added. Are you sure you want to do this?';
            var standardCallback = function (itemToDelete) {

                that.getItems();


                eventBus.$emit('crud-show-new-' + that.name);
                eventBus.$emit('crud-back-to-nav-' + that.name);
            };

            eventBus.$emit('delete-modal-open', title, description, function () {
                axios.delete(appUrls.packages.contacts.destroy.replace('REPLACEME', that.packageId), {params: {contact_id: itemToDelete.id}});
                standardCallback(itemToDelete);
            });
        },
        resetErrors() {
            this.errors = null;
        },
        addItem() {
            var that = this;


            var data = {
                'contact_type': (_.isObject(this.new_item.type) ? this.new_item.type.value : null),
                'position': this.new_item.position
            };

            if (_.isObject(this.new_item.person)) {
                data.person_id = this.new_item.person.value;
            }

            if (_.isObject(this.new_item.company)) {
                data.company_id = this.new_item.company.value;
            }

            var addUrl = appUrls.packages.contacts.store.replace('REPLACEME', this.packageId);

            var standardCallback = function (item) {
                that.new_item = {};
                that.getItems();
                that.current_item = item;
                that.viewItem(item);

            };

            axios.request({
                method: 'post',
                url: addUrl,
                data: data
            }).then(response => {
                standardCallback(response.data.data);
            }).catch(function (error) {
                if (error.response.status === 422) {
                    that.errors = error.response.data.errors;
                }
            });
        },

        // The Big Daddy Of Methods - Retrieves all methods.
        getItems() {
            var that = this;
            var url = appUrls.packages.contacts.index.replace('REPLACEME', this.packageId);
            var getVarName = 'contact';
            var params = {};

            if (this.has_query) {
                params.query = this.search_query;
            }

            axios.get(url, {params: params})
                .then(response => {
                    that.items = _.groupBy(_.sortBy(response.data.data, 'type'), function (contact) {
                        return contact.type;
                    });

                    var hasGetVariable = location.search.indexOf(getVarName + '=') >= 0;
                    if (hasGetVariable) {
                        var idFromVariable = getParameterByName(getVarName);
                        if (fieldWithValueExistsInCollection(that.items, 'id', idFromVariable)) {
                            that.viewItem(getItemByFieldAndValue(that.items, 'id', idFromVariable));
                        }
                    }
                });
        },
        viewItem(item) {
            window.eventBus.$emit('crud-view-item-' + this.name, item);
        },
        backToNav: function () {
            window.eventBus.$emit('crud-back-to-nav-' + this.name);
        },
        backToItem: function () {
            window.eventBus.$emit('crud-back-' + this.name);
        }
    },
    mounted() {
        var that = this;

        this.getItems();

        window.eventBus.$on('crud-search-query-changed-' + this.name, _.debounce(function (query) {
            that.search_query = query;
            that.getItems();
        }, 250));

        window.eventBus.$on('crud-search-hidden-' + this.name, function (query) {
            that.search_query = null;
            that.getItems();
        });

        window.eventBus.$on('crud-errors-dismissed', function () {
            that.errors = null;
        });

        window.eventBus.$on('crud-edit-item-' + this.name, function (item) {
            this.new_item = {};
            this.current_item = item;
            that.resetErrors();
        });

        window.eventBus.$on('crud-delete-item-' + this.name, function (item) {
            that.deleteItem(item);
            that.resetErrors();
        });

        window.eventBus.$on('crud-view-item-' + this.name, function (item) {
            that.new_item = {};
            that.current_item = item;
            that.resetErrors();
        });

        window.eventBus.$on('crud-back-' + this.name, function (item) {
            that.current_item = item;
            that.viewItem(item);
            that.resetErrors();
        });

        window.eventBus.$on('crud-back-to-nav-' + this.name, function () {
            that.current_item = {};
            that.new_item = {};
            that.resetErrors();
        });
    }
}
</script>

<style lang="scss" scoped>
.meta, .name {
    @include clearfix();

    small {
        float: right;
        text-align: right;
    }
}

.name small {
    opacity: 0.5;
}

.meta {
    font-size: 0.8em;
    opacity: 0.5;

    small {
        font-size: 1em;
    }
}

.person-meta, .company-meta {
    @include grid-column(6);
    @include mobile() {
        @include grid-column(12);
    }
}

.position {
    text-align: center;
    font-weight: 300;
    font-size: 2em;
    margin: 1em 0 2em;
}
</style>
